module.exports = __webpack_public_path__ + "static/media/semi_conductors_hero_twitter_card.ccd7f871.jpg";